import { MultiScreenReceiver } from '../controllers/MultiScreenReceiver';
import { OIDCTokenSet } from 'infrastructure/oidc/OIDCClient';
import { Project } from 'core/models/project';
import { Vehicle } from 'core/models/vehicle';
import { SubScreenLayout } from 'core/models/layout';
import { MultiScreenMessage } from './MultiScreenMessage';
import { Environment } from 'core/models/environment';
import { MultiScreenSession } from './MultiScreenSession';

export class MultiScreenClient {
    private receiver: MultiScreenReceiver;
    private _ready = false;

    private _onTokenSet: (tokenSet: OIDCTokenSet) => void = tokenSet => console.log('OIDC Token Set', tokenSet);
    set onTokenSet(callback: (tokenSet: OIDCTokenSet) => void) {
        this._onTokenSet = callback;
    }

    private _onSelectedProject: (selectedProject: Project | null) => void = selectedProject => console.log('Selected Project', selectedProject);
    set onSelectedProject(callback: (selectedProject: Project | null) => void) {
        this._onSelectedProject = callback;
    }

    private _onSelectedEnvironment: (selectedEnvironment: Environment | null) => void = selectedEnvironment => console.log('Selected Environment', selectedEnvironment);
    set onSelectedEnvironment(callback: (selectedEnvironment: Environment | null) => void) {
        this._onSelectedEnvironment = callback;
    }

    private _onVehicleId: (vehicleId: Vehicle.Id | null) => void = vehicleId => console.log('Vehicle ID', vehicleId);
    set onVehicleId(callback: (vehicleId: Vehicle.Id | null) => void) {
        this._onVehicleId = callback;
    }

    private _onCameraLayouts: (layouts: SubScreenLayout[] | null) => void = layouts => console.log('Camera Layouts', layouts);
    set onCameraLayouts(callback: (layout: SubScreenLayout[] | null) => void) {
        this._onCameraLayouts = callback;
    }

    private _onNumberOfScreens: (selected: number) => void = selected => console.log('Number of Screens', selected);
    set onNumberOfScreens(callback: (layout: number) => void) {
        this._onNumberOfScreens = callback;
    }

    constructor(receiver: MultiScreenReceiver) {
        this.receiver = receiver;

        this.receiver.onMessage = (session, msg) => {
            const json = JSON.parse(msg as string) as MultiScreenMessage;
            console.debug({ MultiScreenClient: json });
            switch (json.type) {
                case 'TokenSet':
                    this._onTokenSet(json.tokenSet);
                    break;
                case 'Project':
                    this._onSelectedProject(json.selectedProject);
                    break;
                case 'Environment':
                    this._onSelectedEnvironment(json.selectedEnvironment);
                    break;
                case 'VehicleId':
                    this._onVehicleId(json.vehicleId);
                    break;
                case 'Layouts':
                    this._onCameraLayouts(json.layouts);
                    break;
                case 'NumberOfScreens':
                    this._onNumberOfScreens(json.numberOfScreens);
                    break;
                //
                default:
                    console.warn(`message through ${session.presentationId}`, json);
                    break;
            }
        };

        this.receiver.onSession = session => {
            this.onSession(session);
        };
    }

    start() {
        this._ready = true;

        [...this.receiver.sessions.values()].forEach(session => this.sayHello(session));
    }

    private onSession(session: MultiScreenSession) {
        if (!this._ready) return;

        this.sayHello(session);
    }

    private async _sendMessage(message: MultiScreenMessage, session?: MultiScreenSession) {
        const data = JSON.stringify(message);
        try {
            if (session) {
                await session.send(data);
            } else {
                await this.receiver.sendAll(data);
            }
        } catch (e) {
            console.error(`cannot send message: ${data}`, e);
            throw e;
        }
    }

    private sayHello(session: MultiScreenSession) {
        console.debug({ MultiScreenClient: 'sayHello' });
        this._sendMessage({ type: 'Hello' }, session); // intentionally not awaiting
    }
}
